export default {"src":"/_next/static/media/left_bold.b99dab88.svg","height":24,"width":24};